import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, Output, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { get } from 'lodash';
import { AuctionLaneModel, EditPostingState, SetSelectedAuctionLane, UpdatePosting } from 'remarketing-angular-library';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';


export interface AuctionLaneDisplayData {
  code: string;
  name: string;
  description: string;
  uuid: string;
}
@Component({
    selector: 'app-auction-lane-selection-modal',
    templateUrl: './auction-lane-selection-modal.component.html',
    styleUrls: ['./auction-lane-selection-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent],
    schemas: [NO_ERRORS_SCHEMA]
})
export class AuctionLaneSelectionModalComponent {
  @Input() auctionLaneOptions: AuctionLaneModel[];
  @Input() auctionLaneData: AuctionLaneDisplayData[];
  @Output() closeSelectionModal = new EventEmitter();
  @ViewChild(ModalComponent) modal: ModalComponent;
  _selection: AuctionLaneDisplayData;

  constructor(readonly store: Store) {}

  show() {
    this._selection = undefined;
    this.modal.show();
  }

  saveAndClose() {
    const selected = this.auctionLaneOptions.find(opt => opt.auctionUuid === this._selection.uuid);
    const postingData = this.store.selectSnapshot(EditPostingState.updatedPosting);
    postingData.inventoryItem.auctionUuid = selected.auctionUuid;
    this.store.dispatch(new UpdatePosting(postingData));
    this.store.dispatch(new SetSelectedAuctionLane(selected));
    this.modal.close();
    this.closeSelectionModal.emit(true);
  }

  close() {
    this.modal.close();
  }

  isSelectedAuction(auction: AuctionLaneDisplayData): boolean {
    return auction.uuid === get(this, '_selection.uuid');
  }

  updateSelection(selection: AuctionLaneDisplayData): void {
    this._selection = selection;
  }
}
